module.exports = __webpack_public_path__ + "img/Transparent.6184f12b.png";